import { Flex, Link } from '@chakra-ui/react';

import InnerParentLink from './InnerParentLink';
import type { NavLink } from './useSideNavigation';
import { Link as RouterLink } from 'react-router-dom';
import { useSideNavigation } from './useSideNavigation';

interface ParentLinkProps {
  navLink: NavLink;
  navOpen: boolean | undefined;
}

export default function ParentLink({ navLink, navOpen }: ParentLinkProps) {
  const { parentLinkStyles } = useSideNavigation();

  return navLink.isAngular ? (
    <Flex as={Link} variant="unstyled" href={navLink.route} sx={parentLinkStyles}>
      <InnerParentLink navLink={navLink} navOpen={navOpen} />
    </Flex>
  ) : (
    <Flex as={RouterLink} to={navLink.route} sx={parentLinkStyles}>
      <InnerParentLink navLink={navLink} navOpen={navOpen} />
    </Flex>
  );
}
